export function parseFileSize(bytes = 0, si = false, dp = 1) {
  const thresh = si ? 1000 : 1024

  if (Math.abs(bytes) < thresh) {
    // eslint-disable-next-line prefer-template
    return bytes + ' B'
  }

  const units = si
    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
  let u = -1
  const r = 10 ** dp

  do {
    // eslint-disable-next-line no-param-reassign
    bytes /= thresh
    // eslint-disable-next-line no-plusplus
    ++u
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1)

  // eslint-disable-next-line prefer-template
  return bytes.toFixed(dp) + ' ' + units[u]
}
